module.exports = __webpack_public_path__ + "static/media/stay_clamp.30fa047a.webp";